var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"50.5","cy":"50.5","r":"50.5","transform":"rotate(180 50.5 50.5)","fill":"#F6FDBA","key":0}),React.createElement("path",{"d":"M50.0742 71.7627L50.0742 30.0869","stroke":"#070D0E","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M29.2383 50.9258L50.0762 30.0879L70.9141 50.9258","stroke":"#070D0E","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

ArrowUp.defaultProps = {"width":"50","height":"50","viewBox":"0 0 101 101","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
